module.exports = __webpack_public_path__ + "img/home5.4cbe8eb6.svg";